import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "modal-hint" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "modal-root" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "modal-notify-root" }, null, -1)
const _hoisted_4 = { id: "content-download" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlobalNavigation = _resolveComponent("GlobalNavigation")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppLoader = _resolveComponent("AppLoader")!
  const _component_TableMakeLoader = _resolveComponent("TableMakeLoader")!

  return (_openBlock(), _createElementBlock("main", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_GlobalNavigation),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_view)
    ]),
    (_ctx.isAppLoading)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.isMakingTable)
      ? (_openBlock(), _createBlock(_component_TableMakeLoader, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.isConfigLoading)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}